import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Routes, useLocation, useParams, useNavigate, useMatch, Navigate } from "react-router-dom";
import { Login } from "./Auth/Login";
import RMSMonitor from "./Page/RMSMonitor";
import Nav from "./Partials/Nav";
import SiteCodeMenu from "./Partials/SiteCodeMenu";
import { USER_LOGGED_IN } from "./Reducer/authSlice";
import RealtimeAlarm from "./Page/RealtimeAlarm";
import Alarm from "./Page/Alarm";

import AllSite from "./Page/AllSite";
import { Toaster } from "react-hot-toast";
import SiteDashboard from "./Page/dashboard/SiteDashboard";
import SiteConfiguration from "./Page/dashboard/configuration/SiteConfiguration";
import DcEnergyMeter from "./Page/dashboard/dc_energy/DcEnergyMeter";
import DcGraph from "./Page/dashboard/dc_energy/grpah/dc_graph";
import Overload from "./Page/dashboard/dc_energy/overload/Overload";
import LoadDisconnect from "./Page/dashboard/dc_energy/load_disconnect/LoadDisconnect";
import DcTenant from "./Page/dashboard/dc_energy/dc_tenant/DcTenant";
import DcConsumption from "./Page/dashboard/dc_energy/dc_consumption/DcConsumption";
import SiteAlarm from "./Page/dashboard/alarm/SiteAlarm";
import OnlineSite from "./Page/online_site/OnlineSite";
import OfflineSite from "./Page/offline_site/OfflineSite";
import RmsSiteAlarm from "./Page/dashboard/alarm/rms/RmsSiteAlarm";
import AcEnergyMeter from "./Page/dashboard/ac_energy/AcEnergyMeter";
import SiteAsset from "./Page/dashboard/asset/SiteAsset";
import SitePm from "./Page/dashboard/pm/SitePm";
import SiteSiteDownHistory from "./Page/dashboard/site_down/SiteSiteDownHistory";
import SiteBatteryHome from "./Page/dashboard/battery/SiteBatteryHome";
import CellHome from "./Page/dashboard/battery/app/CellHome";
import Realtime from "./Notification/Realtime";
import CellMonitoring from "./Page/dashboard/battery/app/CellMonitoring";
import BatteryGraph from "./Page/dashboard/battery/app/BatteryGraph";
import PgHome from "./Page/dashboard/pg/PgHome";
import DcEnergy from "./Page/dc_energy/DcEnergy";
import RectifierIndex from "./Page/rectifier/RectifierIndex";
import RmsStation from "./Page/rms_station/RmsStation";
import AllDoor from "./Page/door/AllDoor";
import AcmGraph from "./Page/dashboard/ac_energy/AcmGraph";
import SiteRectifier from "./Page/dashboard/reactifier/SiteRectifier";
import SiteRectifierReport from "./Page/dashboard/reactifier/SiteRectifierReport";
import SiteRectifierGraph from "./Page/dashboard/reactifier/SiteRectifierGraph";
import OfflineDoor from "./Page/offline_site/OfflineDoor";
import JobIndex from "./Page/job/JobIndex";
import IssueIndex from "./Page/issues/IssueIndex";
import VendorIndex from "./Page/vendor/VendorIndex";
import VendorUserIndex from "./Page/vendor_user/VendorUserIndex";
import ReportIndex from "./Page/report/ReportIndex";
import AccessPermission from "./Page/access_permission/AccessPermission";
import NotificationSetting from "./Page/settings/NotificationSetting";
import AiProviderSetting from "./Page/settings/AiProviderSetting";
import SiteTemperature from "./Page/dashboard/temperature/SiteTemperature";
import PasswordChange from "./Page/settings/PasswordChange";
import LoginInformation from "./Page/settings/LoginInformation";
import AcmIndex from "./Page/ac_energy/AcmIndex";
import UserIndex from "./Page/user/UserIndex";
import RoleIndex from "./Page/roles/RoleIndex";
import RmsActiveAlarm from "./Page/rms_alarm/RmsActiveAlarm";
import RmsStatus from "./Page/rms_status/RmsStatus";
import BusinessDashboard from "./Page/business_dashboard/BusinessDashboard";
import RectifierAlarm from "./Page/rectifier_alarm/RectifierAlarm";
import RectifierActiveAlarm from "./Page/rectifier_alarm/RectifierActiveAlarm";
import RmsAlarm from "./Page/rms_alarm/RmsAlarm";

import 'nprogress/nprogress.css'; // Import the styles
import RouteChangeLoader from "./RouteChangeLoader";
import HomeV5 from "./Page/HomeV5";
import FunctionalHome from "./Page/functionalDashboard/FunctionaHome";
import AcsActiveAlarm from "./Page/AcsAlarm/acs_active_alarm";
import SiteDownHistory from "./Page/site_down_history/SiteDownHistory";
import ResetPassword from "./Auth/ResetPassword";
import MapIndex from "./Page/map/MapIndex";
import NotificationAll from "./Page/notification/NotificationAll";
import TenantDashboard from "./Page/tenant/TenantDashboard";
import isTenantUser from "./CustomHook/tenantUser";
import AgentPage from "./Page/agent/AgentPage";

function App() {
  const { accessToken, user: authUser } = useSelector((state) => state.authReducer);
  const selector_offlineID = useSelector((state) => state.offlineIDReducer)
  const rmsAlarmID = useSelector((state) => state.rmsAlarmIdReducer)
  const { user: profileUser } = useSelector((state) => state.profileReducer);
  const user = profileUser?.id ? profileUser : authUser;
  const tenantUser = isTenantUser(user);
  const TENANT_BLOCKED = ['/business_dashboard', '/functional_dashboard', '/issues', '/users', '/roles', '/organisations', '/organisation_users', '/access_permission'];
  const [devToolsOpen, setDevToolsOpen] = useState(false)
  const location = useLocation();
  const dispatch = useDispatch();
  // const match = useMatch('/site/:id');
  // const match1 = useMatch('/site/:id/alarms');
  // const match2 = useMatch('/site/:id/alarms/rms');
const match = /^\/site\/[^/]+(\/.*)?$/.test(location.pathname);
  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem("auth"));
    if (userInfo) {
      dispatch(USER_LOGGED_IN(userInfo));
    }


    // document.addEventListener('contextmenu', function(e) {
    //   e.preventDefault();
    // });


    //   document.onkeydown = function(e) {
    //   if(e.keyCode == 123) {
    //      return false;
    //   }
    //   if(e.ctrlKey && e.shiftKey && e.keyCode == 'I'.charCodeAt(0)) {
    //      return false;
    //   }
    //   if(e.ctrlKey && e.shiftKey && e.keyCode == 'C'.charCodeAt(0)) {
    //      return false;
    //   }
    //   if(e.ctrlKey && e.shiftKey && e.keyCode == 'J'.charCodeAt(0)) {
    //      return false;
    //   }
    //   if(e.ctrlKey && e.keyCode == 'U'.charCodeAt(0)) {
    //      return false;
    //   }
    // }

  }, [dispatch]);


  const publicRoutes = [
  "/reset-password",
  "/forgot-password"
];

const isPublicRoute = publicRoutes.includes(location.pathname);

  // !user ||
  if (!accessToken && !isPublicRoute) {
    return (
      <>
        <Login />
      </>
    );
  }

  // if (user?.is_default == 1) {
  //   return (
  //     <>
  //       <PasswordChange />
  //     </>
  //   );
  // }

if (isPublicRoute) {
  return (
    <Routes>
      <Route path="/reset-password" element={<ResetPassword />} />
    </Routes>
  );
}

if (tenantUser && TENANT_BLOCKED.includes(location.pathname)) {
  return <Navigate to="/" replace />;
}

if (tenantUser) {
  const siteMatch = location.pathname.match(/^\/site\/([^/]+)(\/.*)?$/);
  if (siteMatch) {
    const siteId = siteMatch[1];
    const rest = siteMatch[2] || "";
    if (rest === "/alarms") {
      return <Navigate to={`/site/${encodeURIComponent(siteId)}/alarms/rms`} replace />;
    }
    const allowed =
      rest === "" ||
      rest === "/alarms/rms" ||
      rest.startsWith("/alarms/rms/") ||
      rest === "/dc_energy_meter" ||
      rest.startsWith("/dc_energy_meter/");
    if (!allowed) {
      return <Navigate to={`/site/${encodeURIComponent(siteId)}`} replace />;
    }
  }
}

  return (
    <>
      <Realtime />
      {location.pathname == '/agent' || location.pathname =='/map' || location.pathname=='all_notifications' || location.pathname == '/rectifier_alarm_history' || location.pathname.startsWith('/acs_alarm_filter') || location.pathname == '/rectifier_live_alarm'||  location.pathname == '/functional_dashboard' || location.pathname == '/business_dashboard' || location.pathname == '/roles' || location.pathname == '/users' || location.pathname == '/acm-monitoring' || location.pathname == '/login-information' || location.pathname == '/password-change' || location.pathname == '/notification_setting' || location.pathname == '/ai-provider' || location.pathname == '/reports' || location.pathname == '/access_permission' || location.pathname == '/organisation_users' || location.pathname == '/organisations' || location.pathname == '/rms_stations' || location.pathname == '/all_jobs' || location.pathname == '/issues' || location.pathname == '/all_doors' || location.pathname == '/rectifier_monitoring' || location.pathname === '/' || location.pathname == '/timeline' || location.pathname == '/alarms' || location.pathname == '/rms_alarms' || location.pathname == '/all_sites' || location.pathname == '/offline_sites' || location.pathname == '/offline_sites/' + selector_offlineID.data || location.pathname == '/online_sites' || location.pathname == '/dc_energy' || location.pathname == `/rms_alarm_filter/${rmsAlarmID?.data}/fatch`|| location.pathname =='/site_down_history/fetch' ? '' : (match?<SiteCodeMenu />:'') }

      <div className={`page ${location.pathname == '/agent' || location.pathname =='/map'|| location.pathname=='/all_notifications' || location.pathname == '/rectifier_alarm_history' || location.pathname.startsWith('/acs_alarm_filter') || location.pathname == '/rectifier_live_alarm' ||  location.pathname == '/functional_dashboard' || location.pathname == '/business_dashboard' || location.pathname == '/roles' || location.pathname == '/users' || location.pathname == '/acm-monitoring' || location.pathname == '/login-information' || location.pathname == '/password-change' || location.pathname == '/reports' || location.pathname == '/notification_setting' || location.pathname == '/ai-provider' || location.pathname == '/access_permission' || location.pathname == '/organisation_users' || location.pathname == '/organisations' || location.pathname == '/rms_stations' || location.pathname == '/all_jobs' || location.pathname == '/issues' || location.pathname == '/all_doors' || location.pathname === '/' || location.pathname == '/rectifier_monitoring' || location.pathname == '/timeline' || location.pathname == '/alarms' || location.pathname == '/rms_alarms' || location.pathname == '/all_sites' || location.pathname == '/offline_sites' || location.pathname == '/offline_sites/' + selector_offlineID.data || location.pathname == '/online_sites' || location.pathname == '/dc_energy' || location.pathname == `/rms_alarm_filter/${rmsAlarmID?.data}/fatch`|| location.pathname =='/site_down_history/fetch' ? 'left-home' : ''}`}>
        {location.pathname !== '/agent' && <Nav />}

        <div className="section-body">
          <RouteChangeLoader />
          <Routes>
            <Route path="/" element={tenantUser ? <TenantDashboard /> : <HomeV5 />} />
            <Route path="/business_dashboard" element={<BusinessDashboard />} />
            <Route path="/monitoring" element={<RMSMonitor />} />
            <Route path="/online_sites" element={<OnlineSite />} />
            <Route path="/offline_sites" element={<OfflineSite />} />
            <Route path="/offline_sites/:id" element={<OfflineDoor />} />
            <Route path="/timeline" element={<RealtimeAlarm />} />
            <Route path="/alarms" element={<Alarm />} />
            <Route path="/rms_alarms" element={<RmsAlarm />} />
            <Route path="/door_management/all_door" element={<AllDoor />} />
            <Route path="/rms_stations" element={<RmsStatus />} />
            <Route path="/all_rms" element={<RmsStation />} />
            <Route path="/all_doors" element={<AllDoor />} />
            <Route path="/all_sites" element={<AllSite />} />
            <Route path="/reports" element={<ReportIndex />} />
            <Route path="/agent" element={<AgentPage />} />

            <Route path="/site/:id" element={<SiteDashboard />} />
            <Route path="/site/:id/configuration" element={<SiteConfiguration />} />
            <Route path="/site/:id/dc_energy_meter" element={<DcEnergyMeter />} />
            <Route path="/site/:id/dc_energy_meter/graph" element={<DcGraph />} />
            <Route path="/site/:id/dc_energy_meter/overload" element={<Overload />} />
            <Route path="/site/:id/dc_energy_meter/load_disconnect" element={<LoadDisconnect />} />
            <Route path="/site/:id/dc_energy_meter/dc_tenant" element={<DcTenant />} />
            <Route path="/site/:id/dc_energy_meter/dc_consumption" element={<DcConsumption />} />

            <Route path="/site/:id/alarms" element={<SiteAlarm />} />
            <Route path="/site/:id/alarms/rms" element={<RmsSiteAlarm />} />
            <Route path="/site/:id/ac_energy_meter/:acm_id" element={<AcEnergyMeter />} />
            <Route path="/site/:id/ac_energy_meter/:acm_id/graph" element={<AcmGraph />} />
            <Route path="/site/:id/assets" element={<SiteAsset />} />
            <Route path="/site/:id/pm" element={<SitePm />} />
            <Route path="/site/:id/site_down_history" element={<SiteSiteDownHistory />} />
            <Route path="/site/:id/bms" element={<SiteBatteryHome />} />
            <Route path="/site/:id/bms/:sl/dashboard" element={<CellHome />} />
            <Route path="/site/:id/bms/:sl/cell_monitoring" element={<CellMonitoring />} />
            <Route path="/site/:id/bms/:sl/graph" element={<BatteryGraph />} />
            <Route path="/site/:id/pg" element={<PgHome />} />
            <Route path="/site/:id/rectifier/:rid" element={<SiteRectifier />} />
            <Route path="/site/:id/rectifier/:rid/report" element={<SiteRectifierReport />} />
            <Route path="/site/:id/rectifier/:rid/graph" element={<SiteRectifierGraph />} />
            <Route path="/site/:id/temperature" element={<SiteTemperature />} />

            <Route path="/dc_energy" element={<DcEnergy />} />
            <Route path="/rectifier_monitoring" element={<RectifierIndex />} />
            {/*             
            <Route path="/site/:id/assets" element={<DcEnergyMeter />}/>
            <Route path="/site/:id/solar/:sl_no" element={<DcEnergyMeter />}/>
            <Route path="/site/:id/rectifer/:sl_no" element={<DcEnergyMeter />}/>
            <Route path="/site/:id/pg_status" element={<DcEnergyMeter />}/>
            <Route path="/site/:id/map" element={<DcEnergyMeter />}/> */}
            <Route path="/all_jobs" element={<JobIndex />} />
            <Route path="/issues" element={<IssueIndex />} />
            <Route path="/organisations" element={<VendorIndex />} />
            <Route path="/organisation_users" element={<VendorUserIndex />} />
            <Route path="/access_permission" element={<AccessPermission />} />
            <Route path="/notification_setting" element={<NotificationSetting />} />
            <Route path="/ai-provider" element={<AiProviderSetting />} />
            <Route path="/all_notifications" element={<NotificationAll />} />
            <Route path="/password-change" element={<PasswordChange />} />
            <Route path="/login-information" element={<LoginInformation />} />
            <Route path="/acm-monitoring" element={<AcmIndex />} />
            <Route path="/users" element={<UserIndex />} />
            <Route path="/roles" element={<RoleIndex />} />
            <Route path="/rms_alarm_filter/:id/fatch" element={<RmsActiveAlarm />} />
            <Route path="/rectifier_alarm_history" element={<RectifierAlarm />} />
            <Route path="/rectifier_live_alarm" element={<RectifierActiveAlarm />} />
            <Route path="/functional_dashboard" element={<FunctionalHome />} />
            <Route path="/acs_alarm_filter/:id/fatch" element={<AcsActiveAlarm />} />
            <Route path="/site_down_history/fetch" element={<SiteDownHistory />} />
            <Route path="/map" element={<MapIndex />} />

          </Routes>

        </div>
        <Toaster
          position="top-center"
          reverseOrder={false}
        />
        {/* <Footer /> */}
      </div>

    </>

  );
}

export default App;
